var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiddingBasic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04761 34.0343L28.1693 44.0438L28.1694 44.0438L27.344 53.8951L58 42.3773V32.8425L57.9999 32.8425L36.8677 22.833L7.04761 34.0343Z",
    fill: "#FFE4A0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_751_6922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1693 44.0438L7.04761 34.0343L36.8677 22.833L57.9999 32.8425L28.1693 44.0438Z",
    fill: "#AE9554"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.762 38.3159L11.0583 28.2009C10.1165 27.663 8.92075 28.1482 8.62445 29.1924L3.15356 48.2304L22.7197 59.3895L28.762 38.3159Z",
    fill: "#927C46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7958 37.7727C33.4459 39.08 31.9787 39.7306 30.7749 39.1123L16.4406 31.7495C15.5515 31.2928 15.1013 30.2778 15.3597 29.3122L22.3076 3.35143C22.6575 2.04416 24.1247 1.3935 25.3285 2.01182L39.6628 9.37459C40.5519 9.83129 41.0021 10.8464 40.7436 11.8119L33.7958 37.7727Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4787 41.9856C31.1288 43.2928 29.6615 43.9435 28.4578 43.3252L14.1235 35.9624C13.2343 35.5057 12.7842 34.4906 13.0426 33.5251L19.9904 7.56432C20.3403 6.25705 21.8076 5.60639 23.0113 6.22471L37.3456 13.5875C38.2348 14.0442 38.6849 15.0592 38.4265 16.0248L31.4787 41.9856Z",
    fill: "#C5BED6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0888 46.9094C28.7389 48.2167 27.2716 48.8673 26.0679 48.249L11.7336 40.8862C10.8444 40.4295 10.3943 39.4145 10.6527 38.4489L17.6006 12.4882C17.9504 11.1809 19.4177 10.5302 20.6214 11.1485L34.9558 18.5113C35.8449 18.968 36.295 19.9831 36.0366 20.9487L29.0888 46.9094Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6837 51.6516C26.3339 52.9589 24.8666 53.6095 23.6628 52.9912L9.32853 45.6284C8.43939 45.1717 7.98926 44.1567 8.24768 43.1911L15.1955 17.2303C15.5454 15.9231 17.0126 15.2724 18.2164 15.8907L32.5507 23.2535C33.4399 23.7102 33.89 24.7253 33.6316 25.6909L26.6837 51.6516Z",
    fill: "#C5BED6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_751_6922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1326 30.2971C28.8321 30.6673 29.1832 31.4715 28.9792 32.2361L23.5302 52.659C23.251 53.7055 22.0767 54.2268 21.1132 53.7319L6.49249 46.222C5.78162 45.8569 5.42146 45.0456 5.62748 44.2734L11.0786 23.8424C11.3556 22.8039 12.5156 22.2807 13.4775 22.7603L15.118 23.5783C16.0808 24.0584 17.2416 23.5339 17.5175 22.4941L17.9072 21.026C18.1853 19.9779 19.361 19.4553 20.3254 19.9512L24.2688 21.9787C24.9776 22.3431 25.3377 23.1513 25.1346 23.922L24.3707 26.8209C24.1695 27.5842 24.5208 28.3855 25.2185 28.7548L28.1326 30.2971Z",
    fill: "url(#paint0_linear_751_6922)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1694 44.0431L27.344 53.8944L58 42.3766V32.8418L28.1694 44.0431Z",
    fill: "#FFE4A0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    filter: "url(#filter2_f_751_6922)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9527 52.3702L31.2956 41.7338L30.1645 41.5254L26.7852 52.6457L27.9527 52.3702Z",
    fill: "#382956"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_751_6922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4972 46.2802L6.93109 35.1211L3.15332 48.2315L22.7194 59.4012L26.4972 46.2802Z",
    fill: "#FFE4A0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2528 38.3998C35.3983 37.7699 34.8147 37.2149 34.1929 37.3919L30.7781 38.3638C29.3402 38.7731 28.2235 39.9083 27.838 41.3527L27.238 43.6007L27.2486 43.6113L22.7195 59.4007L25.9258 58.7784L30.3914 43.2105L34.4972 41.6705L35.2528 38.3998Z",
    fill: "url(#paint1_linear_751_6922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_751_6922",
    x: 6.623,
    y: 22.4084,
    width: 51.377,
    height: 21.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.424609,
    dy: -0.424609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424609
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.398067 0 0 0 0 0.221667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_751_6922"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_751_6922",
    x: 0.47452,
    y: 16.7904,
    width: 35.3558,
    height: 46.0472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.849217,
    dy: 2.97226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.97226
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321296 0 0 0 0 0.234017 0 0 0 0 0.504167 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_751_6922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_751_6922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_751_6922",
    x: 25.0867,
    y: 39.827,
    width: 7.90737,
    height: 14.517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.849217,
    result: "effect1_foregroundBlur_751_6922"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_751_6922",
    x: 3.15332,
    y: 34.6965,
    width: 23.344,
    height: 24.7049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.424609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424609
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.721569 0 0 0 0 0.462745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_751_6922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_751_6922",
    x1: 27.8128,
    y1: 24.2884,
    x2: 14.6963,
    y2: 61.1947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_751_6922",
    x1: 35.4998,
    y1: 26.5,
    x2: 21.4998,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingBasic);
export default __webpack_public_path__ + "static/media/bidding_basic.c6f8b273698ae52e0f2260b508d71340.svg";
export { ForwardRef as ReactComponent };